export const unitFaq = {
  head: {
    title: "Questions et réponses de l'unité",
    chip: "IA",
    subPre: "Réponses spécifiques à",
    subStrong: "cette unité",
    subPost: ". L'agent les utilisera en priorité pour aider un client séjournant ici (p. ex. son code de porte, les particularités de cet appartement…). Joignez des images ou des vidéos et l'agent les enverra dès que le client en aura besoin.",
  },
  clone: {
    titleNoun: "FAQ",
    itemNoun: "les FAQ",
    buttonLabel: "Cloner les questions",
  },

  copyOne: {
    title: "Copier cette question",
    itemNoun: "question",
  },
  loading: "Chargement…",
  emptyList: "Aucune question pour le moment. Ajoutez la première pour que l'agent sache comment y répondre.",
  list: {
    newQuestion: "Nouvelle question",
    attachments: "{count} pièce jointe | {count} pièces jointes",
    learnedTitle: "Ajouté par auto-apprentissage",
    deleteTitle: "Supprimer",
    copyTitle: "Copier vers d'autres logements",
  },
  form: {
    questionLabel: "Question",
    answerLabel: "Réponse de l'agent",
    qPlaceholder: "Question · p. ex. Quel est le code de la porte ?",
    aPlaceholder: "Réponse · p. ex. Le code d'entrée de votre immeuble est 4512.",
    removeAttachment: "Supprimer la pièce jointe",
    uploading: "Téléchargement…",
    attach: "Joindre",
    addQuestion: "Ajouter la question",
  },
  preview: {
    tag: "Aperçu · WhatsApp",
    online: "en ligne",
    aiReception: "Réception IA",
    questionPlaceholder: "Saisissez la question du client…",
    answerPlaceholder: "Saisissez la réponse que l'agent donnera…",
    videoFile: "Vidéo",
    genericFile: "Fichier",
    empty: "Sélectionnez ou créez une question pour voir comment l'agent répondra.",
    hint: "Voici comment le client le verra dans son chat",
  },
  footer: {
    saved: "Enregistré",
    save: "Enregistrer les modifications",
  },
  errors: {
    load: "Impossible de charger les questions.",
    attachNeedsQA: "Rédigez la question et la réponse avant de joindre des fichiers.",
    attachNeedsSave: "Enregistrez d'abord pour pouvoir joindre des fichiers.",
    upload: "Impossible de télécharger le fichier.",
    deleteFile: "Impossible de supprimer le fichier.",
    save: "Impossible d'enregistrer.",
  },
};
